import { useCallback } from 'react';

import { di } from 'react-magnetic-di';

import type { CardEventHandler } from '@atlaskit/media-card/actions';
import type { FileItem } from '@atlaskit/media-client';

import type { FieldId } from '../../../../../../../../../../common/types/form/form-fields';
import {
	FileStatus,
	type FilesValue,
} from '../../../../../../../../../../common/types/form/form-fields/field-values';
import {
	useCurrentValue,
	useFormRendererActions,
} from '../../../../../../../../../../controllers/form-renderer-store';

export const useOnRemoveFile: (
	currentFilesValue: FilesValue,
	fieldId: FieldId,
) => CardEventHandler = (currentFilesValue: FilesValue, fieldId: FieldId) => {
	di(useCurrentValue, useFormRendererActions);

	const { updateModifiedValue } = useFormRendererActions();

	const onRemoveFile: CardEventHandler = useCallback(
		(fileToRemove?: FileItem) => {
			if (!fileToRemove) {
				return;
			}

			const updatedFiles = currentFilesValue.files.filter(
				(formfile) => formfile.identifier.id !== fileToRemove.details.id,
			);

			if (updatedFiles.length === 0) {
				updateModifiedValue(fieldId, null);
			} else {
				updateModifiedValue(fieldId, {
					files: updatedFiles,
					fileStatus: FileStatus.UPLOADED,
				});
			}
		},
		[currentFilesValue, fieldId, updateModifiedValue],
	);

	return onRemoveFile;
};
